import type { KatalogAuswahl } from './typen';

/**
 * Auswahl → Felder des Eintrags (InspectionItem) im Schritt „Details“.
 * Der Aufrufer spreizt `felder` über seinen Entwurf; was hier fehlt, bleibt
 * wie es war (z. B. die heutige Frist +14 Tage ohne Dringlichkeit).
 */

export interface Vorbelegung {
    felder: {
        title?: string;
        observation?: string;
        regulation?: string;
        deadline?: string;
        immediateAction?: boolean;
        katalogKey: string | null;
        katalogKategorie: string | null;
    };
    /** Titel/Text enthalten eine Lücke → gelber Hinweis „Angabe ergänzen“. */
    platzhalter: boolean;
}

/** Lokales Datum YYYY-MM-DD (keine UTC-Verschiebung um Mitternacht). */
export function lokalesDatum(d: Date): string {
    const j = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const t = String(d.getDate()).padStart(2, '0');
    return `${j}-${m}-${t}`;
}

/** heute + tage als lokales Datum (Kalendertage, sommerzeitfest). */
export function datumPlusTage(heute: Date, tage: number): string {
    return lokalesDatum(new Date(heute.getFullYear(), heute.getMonth(), heute.getDate() + tage));
}

export function katalogFelderLeeren(): { katalogKey: null; katalogKategorie: null } {
    return { katalogKey: null, katalogKategorie: null };
}

/**
 * Freitext: nur die katalog*-Felder (Kategorie gesetzt). Standardmangel:
 * Titel, Beschreibung, gekürzte Vorschrift und katalog*. Dringlichkeit
 * 'sofort' → Sofortmaßnahme ohne Frist; 'frist' mit fristTage → Frist ab
 * heute; ohne Dringlichkeit bleiben deadline/immediateAction unberührt.
 */
export function vorbelegungAus(a: KatalogAuswahl, heute: Date): Vorbelegung {
    const katalog = {
        katalogKey: a.art === 'freitext' ? null : a.katalogKey ?? null,
        katalogKategorie: a.katalogKategorie ?? null,
    };
    const v = a.art === 'freitext' ? null : a.vorlage;
    if (!v) return { felder: katalog, platzhalter: false };

    const felder: Vorbelegung['felder'] = {
        title: v.titel,
        observation: v.text,
        regulation: v.vorschrift,
        ...katalog,
    };
    if (v.dringlichkeit === 'sofort') {
        felder.immediateAction = true;
        felder.deadline = '';
    } else if (
        v.dringlichkeit === 'frist' &&
        typeof v.fristTage === 'number' &&
        Number.isFinite(v.fristTage) &&
        v.fristTage >= 1
    ) {
        felder.immediateAction = false;
        felder.deadline = datumPlusTage(heute, Math.round(v.fristTage));
    }
    return { felder, platzhalter: v.platzhalter === true };
}
